import React, {Component} from 'react';
import { Select, SelectItem } from '@carbon/react';
import PropertyComponent from './PropertyComponent';
import * as midi from '../js/rpl_midi.js';

class DevicePropertySelect extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return (
	  		<Select labelText={this.labelText} value={this.state.value} onChange={this.handleChange} disabled={this.state.disabled}>
			{this.props.children}
			</Select>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setDeviceProperty(this.propId, [newValue]);
	}

	handleControlChange(ccNum, ccValue) {
		this.setValue(ccValue);
	}

	setValue(x) {
		this.setState({value: x});
	}
}

export default DevicePropertySelect;
